import { loginRequest, graphConfig } from "../authConfig";
import { msalInstance } from "../index";

export async function callMsGraph() {
  const account = msalInstance.getActiveAccount();
  if (!account) {
    throw Error(
      "No active account! Verify a user has been signed in and setActiveAccount has been called.",
    );
  }

  const tokenResponse = await msalInstance.acquireTokenSilent({
    ...loginRequest,
    account: account,
  });

  const headers = new Headers();
  headers.append("Authorization", `Bearer ${tokenResponse.accessToken}`);

  const response = await fetch(graphConfig.graphMeEndpoint, {
    method: "GET",
    headers: headers,
  });

  if (!response.ok) {
    throw new Error(
      `MS Graph API call failed: ${response.status} ${response.statusText}`,
    );
  }

  return response.json();
}
